import React, { useEffect, useState } from "react";
import PieChart from "../../../components/Chart/PieChart";
import { observer } from "mobx-react";
import GlobelStore from "../../../Store/GlobelStore";

const PieChartAdminEmployee = observer(() => {
  const [series, setSeries] = useState([
    { name: "Active", data: 0 },
    { name: "Inactive", data: 0 },
  ]);
  const [total, setTotal] = useState(0);
  useEffect(() => {
    const clientData = GlobelStore?.dashboardAllData?.adminEmployeeData;
    if (clientData) {
      setSeries(clientData?.series || []);
      setTotal(clientData?.total || 0);
    }
  }, [GlobelStore?.dashboardAllData]);

  const activeData = series.find((item) => item.name === "Active")?.data || 0;
  const inactiveData =
    series.find((item) => item.name === "Inactive")?.data || 0;

  return (
    <div className="EmployeeChartMainContainerMini">
      <div className="titleContainer">
        <div className="title">Admin Employee</div>
      </div>
      <div className="statsContainer">
        <div className="pieChartDiv">
          <PieChart series={series} total={total} />
        </div>
        <div className="detailContainer">
          <div className="subDetailContainerPieChart">
            <div className="detailTitleTotal">Total:</div>
            <div className="detailValueTotal">{total}</div>
          </div>
          <div className="subDetailContainerPieChart">
            <div className="detailTitleActive">Active:</div>
            <div className="detailValueActive ">{activeData}</div>
          </div>
          <div className="subDetailContainerPieChart">
            <div className="detailTitleNotWorking">Not Working:</div>
            <div className="detailValueNotWorking">{inactiveData}</div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default React.memo(PieChartAdminEmployee);
